import { render } from "./SectionHead.vue?vue&type=template&id=3ea2a97e&scoped=true"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"

import "./SectionHead.vue?vue&type=style&index=0&id=3ea2a97e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea2a97e"]])

export default __exports__